import * as React from 'react'
import { IconButton } from '@doordash/component-button'
import { TemplateResponseData } from './types'
import { SubmitOnboardingCallback } from 'src/components/pages/onboarding-workflow/OnboardingWorkflow'

type BackButtonProps = {
  backButtonData: TemplateResponseData
  onSubmitStep: SubmitOnboardingCallback
}

export const BackButton: React.FC<BackButtonProps> = ({
  backButtonData,
  onSubmitStep,
}) => {
  const onClick = () => {
    onSubmitStep(backButtonData)
  }

  return (
    <IconButton
      size={IconButton.Sizes.Medium}
      accessibilityLabel="backButton"
      iconType={IconButton.IconTypes.ArrowLeft}
      onClick={onClick}
    />
  )
}
